import { useEffect, useState } from "react";
import ThemeModal from "../cmp/ThemeModal";
import { FaEdit } from "react-icons/fa";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { MdWarning } from "react-icons/md";
import { GetProductCategory, Alerts } from "../../helpers";
const EditProductVariation = ({ variation, productId, isSingleVartion, handleCloseVariation, onVariationUpdated }) => {

    const variationObj = JSON.parse(variation.variations);
    const [variations, setVartiaitons] = useState([]);
    const [isUnit, setIsUnit] = useState(variation?.unit_name !== null);
    const [visibleInputs, setVisibleInputs] = useState({});

    const setInitialVisibility = (variationData) => {
        const initialVisibility = variationData.reduce((acc, variation) => {
            acc[variation.name] = false;
            return acc;
        }, {});
        setVisibleInputs(initialVisibility);
    }



    const getVariations = async () => {
        const resp = await GetProductCategory.getVariations();

        if (resp && resp.status) {
            setVartiaitons(resp.variations);

            const initialVisibility = resp.variations.reduce((acc, v) => {
                acc[v.name] = variationObj[v.slug] ? true : false;
                return acc;
            }, {});
            setVisibleInputs(initialVisibility);


            const initialValues = resp.variations.reduce((acc, v) => {
                acc[v.slug] = variationObj[v.slug] || "";
                return acc;
            }, {
                sku: variation?.sku || "",
                stock: variation?.stock || "",
                regular_price: variation?.regular_price || "",
                sale_price: variation?.sale_price || "",
                unit_value: variation?.unit_value || "",
                unit_name: variation?.unit_name || ""
            });

            formik.setValues(initialValues);
        }
    };


    useEffect(() => {
        getVariations();
    }, [])

    const toggleInputVisibility = (name) => {
        setVisibleInputs((prev) => ({
            ...prev,
            [name]: !prev[name],
        }));
    };
    const generateValidationSchema = () => {
        let schema = {
            sku: Yup.string()
                .typeError("SKU must be a string")
                .required("SKU is required"),
            stock: Yup.number()
                .typeError("Quantity must be a number")
                .min(1, "Quantity must be at least 1")
                .required("Quantity is required"),
            regular_price: Yup.number()
                .typeError("Price must be a number")
                .min(1, "Price must be at least 1")
                .required("Price is required"),
            sale_price: Yup.number()
                .typeError("Price must be a number")
                .required("Price is required"),
        };
        if (isUnit) {
            schema.unit_value = Yup.number()
                .typeError("Unit value must be a number")
                .required("Unit value is required");
            schema.unit_name = Yup.string()
                .typeError("Unit name must be a string")
                .required("Unit name is required");

        }

        variations.forEach((variation) => {
            if (variation) {
                if (visibleInputs[variation.name]) {
                    schema[variation.slug] = Yup.string().required(`${variation.name} is required`);
                }
            }

        });

        return Yup.object(schema);
    };


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            sku: "",
            stock: "",
            regular_price: "",
            sale_price: "",
            unit_value: "",
            unit_name: ""
        },
        validationSchema: generateValidationSchema(),
        onSubmit: async (values) => {
            const filteredValues = Object.keys(values).reduce((acc, key) => {
                if (values[key] && visibleInputs[key] !== false) {
                    acc[key] = values[key];
                }
                return acc;
            }, {});

            const { sku, stock, regular_price, sale_price, unit_value, unit_name, ...updatedObj } = filteredValues;
            const data = {
                productId: productId,
                variations: updatedObj,
                sku: sku,
                stock: stock,
                regular_price: regular_price,
                sale_price: sale_price,
                unit_value: unit_value ? unit_value : "",
                unit_name: unit_name ? unit_name : ""
            }
            const resp = await GetProductCategory.updateProductVariation(variation.id, data);
            if (resp && resp.status) {
                onVariationUpdated(resp.payload);
                Alerts.alertMessage(resp.message, 'top-right', 'success');
            } else {
                Alerts.alertMessage(resp.message, 'top-right', 'error')
            }
        },

    });

    return (
        <>

            <ThemeModal show={isSingleVartion} handleHide={handleCloseVariation} title={'Edit Variation'}>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row" style={{ marginBottom: 20 }}>
                        <div className="col-md-6">
                            <label htmlFor="sku">SKU</label>
                            <input
                                type="text"
                                id="sku"
                                name="sku"
                                className="form-control"
                                placeholder="Enter SKU"
                                value={formik.values.sku}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.sku && formik.errors.sku ? (
                                <div style={{ color: "red", fontSize: 12 }}>
                                    {formik.errors.sku}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="stock">Stock</label>
                            <input
                                type="number"
                                id="stock"
                                name="stock"
                                className="form-control"
                                placeholder="Enter quantity"
                                value={formik.values.stock}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.stock && formik.errors.stock ? (
                                <div style={{ color: "red", fontSize: 12 }}>
                                    {formik.errors.stock}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="regular_price">Price</label>
                            <div className="priceBox">
                                <div className="priceIcon">£</div>
                                <input
                                    type="number"
                                    id="regular_price"
                                    name="regular_price"
                                    className="form-control"
                                    placeholder="Enter price"
                                    value={formik.values.regular_price}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            {formik.touched.regular_price && formik.errors.regular_price ? (
                                <div style={{ color: "red", fontSize: 12 }}>
                                    {formik.errors.regular_price}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="sale_price">Sale Price</label>
                            <div className="priceBox">
                                <div className="priceIcon">£</div>
                                <input
                                    type="number"
                                    id="sale_price"
                                    name="sale_price"
                                    className="form-control"
                                    placeholder="Enter sale price"
                                    value={formik.values.sale_price}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>

                            {formik.touched.sale_price && formik.errors.sale_price ? (
                                <div style={{ color: "red", fontSize: 12 }}>
                                    {formik.errors.sale_price}
                                </div>
                            ) : null}
                        </div>




                    </div>
                    <div className="row" style={{ marginTop: 15 }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label htmlFor={`isVariation`} className="isUnit">
                                    <input
                                        type="checkbox"
                                        name="variation"
                                        id={`isVariation`}
                                        checked={isUnit}
                                        onClick={() => setIsUnit(!isUnit)}
                                    />
                                    <span>IsUnit Details</span>
                                </label>
                            </div>
                            {
                                isUnit && (
                                    <>
                                        <div className="col-md-6">
                                            <label htmlFor="unit_value">Unit Value</label>
                                            <input
                                                type="text"
                                                id="unit_value"
                                                name="unit_value"
                                                className="form-control"
                                                placeholder="Enter unit value"
                                                value={formik.values.unit_value}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.unit_value && formik.errors.unit_value ? (
                                                <div style={{ color: "red", fontSize: 12 }}>
                                                    {formik.errors.unit_value}
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="unit_name">Unit Name</label>

                                            <input
                                                type="text"
                                                id="unit_name"
                                                name="unit_name"
                                                className="form-control"
                                                placeholder="Enter unit name"
                                                value={formik.values.unit_name}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.unit_name && formik.errors.unit_name ? (
                                                <div style={{ color: "red", fontSize: 12 }}>
                                                    {formik.errors.unit_name}
                                                </div>
                                            ) : null}
                                        </div>
                                    </>


                                )
                            }

                        </div>

                    </div>
                    <div className="variationList list2 mt-3">
                        <h5>Variations</h5>
                        <ul>
                            {variations.length > 0 ? (
                                variations.map((item, i) => {
                                    return (
                                        <li key={i}>
                                            <label htmlFor={`variation_${i}`}>
                                                <input
                                                    type="checkbox"
                                                    name="variation"
                                                    id={`variation_${i}`}
                                                    checked={visibleInputs[item.name] || false}
                                                    onChange={() =>
                                                        toggleInputVisibility(item.name)
                                                    }
                                                />
                                                {item.name}
                                            </label>
                                            {visibleInputs[item.name] && (
                                                <div style={{ marginTop: 10, marginRight: 5 }}>
                                                    {item.input_type === "text" && (
                                                        <input
                                                            type="text"
                                                            placeholder={`Enter ${item.name}`}
                                                            className="form-control mr-3"
                                                            id={item.name}
                                                            name={item.slug}
                                                            value={formik.values[item.slug]}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    )}
                                                    {item.input_type === "number" && (
                                                        <input
                                                            type="number"
                                                            placeholder={`Enter ${item.name}`}
                                                            className="form-control"
                                                            id={item.name}
                                                            name={item.slug}
                                                            value={formik.values[item.slug]}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    )}
                                                    {item.input_type === "textarea" && (
                                                        <textarea
                                                            placeholder={`Enter ${item.name}`}
                                                            className="form-control"
                                                            rows="3"
                                                            id={item.name}
                                                            name={item.slug}
                                                            value={formik.values[item.slug]}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        ></textarea>
                                                    )}
                                                    {formik.touched[item.slug] &&
                                                        formik.errors[item.slug] && (
                                                            <div
                                                                style={{
                                                                    color: "red",
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                {formik.errors[item.slug]}
                                                            </div>
                                                        )}
                                                </div>
                                            )}
                                        </li>
                                    );
                                })
                            ) : (
                                <p
                                    style={{
                                        color: "#881212",
                                        fontSize: 14,
                                        marginTop: 10,
                                    }}
                                >
                                    <MdWarning size={18} /> Variation not found!
                                </p>
                            )}
                        </ul>
                    </div>
                    <button type="submit" className="btn btn-primary" style={{ marginTop: 20 }}>
                        Submit
                    </button>
                </form>
            </ThemeModal>
        </>
    )
}

export default EditProductVariation;